import React from "react";
import Footer from "../../components/Footer";
import Contact from "./ContactView";

export function ContactContainer() {
  return (
    <div>
      <Contact title="Contact"/>
      <Footer/>
    </div>
  );
}
